import { ChevronLeft, ChevronRight } from 'lucide-react';

interface ArtifactsPaginationProps {
  page: number;
  hasNext: boolean;
  onPageChange: (page: number) => void;
}

export function ArtifactsPagination({
  page,
  hasNext,
  onPageChange,
}: ArtifactsPaginationProps): React.ReactElement | null {
  const isFirstPage = page === 0;
  if (isFirstPage && !hasNext) return null;

  return (
    <div className="flex items-center justify-end gap-2 pt-2 text-sm text-text-secondary">
      <button
        type="button"
        onClick={() => {
          onPageChange(Math.max(0, page - 1));
        }}
        disabled={isFirstPage}
        className="inline-flex items-center gap-1 rounded-md border border-border bg-surface px-2 py-1 disabled:opacity-50"
        aria-label="Previous page"
      >
        <ChevronLeft className="size-4" />
        Prev
      </button>
      <span aria-live="polite">Page {page + 1}</span>
      <button
        type="button"
        onClick={() => {
          onPageChange(page + 1);
        }}
        disabled={!hasNext}
        className="inline-flex items-center gap-1 rounded-md border border-border bg-surface px-2 py-1 disabled:opacity-50"
        aria-label="Next page"
      >
        Next
        <ChevronRight className="size-4" />
      </button>
    </div>
  );
}
